import {AxiosRequestHeaders} from 'axios';
import request from '../../axios';

export interface IDeleteAccountNumberPayload {
  guid: string;
}

export const deleteAccountNumber = async (
  payload: IDeleteAccountNumberPayload,
) => {
  const {data} = await request.delete(`/api/profile/bank-account-info`, {
    headers: {} as AxiosRequestHeaders,
    data: {...payload},
  });

  return data;
};
